export default __webpack_public_path__ + "static/media/04_2.0fc990cd.png";